(() => {
  const closeItem = (item, restoreFocus = false) => {
    const trigger = item?.querySelector('[data-msp-faq-trigger]');
    const panel = item?.querySelector('[data-msp-faq-panel]');
    if (!trigger || !panel || trigger.getAttribute('aria-expanded') !== 'true') return;
    trigger.setAttribute('aria-expanded', 'false');
    panel.classList.remove('is-open');
    const finish = () => {
      if (trigger.getAttribute('aria-expanded') === 'false') panel.hidden = true;
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else setTimeout(finish, 170);
    if (restoreFocus) trigger.focus({ preventScroll: true });
  };

  const openItem = (item) => {
    const root = item.closest('[data-msp-faq-accordion]');
    const trigger = item.querySelector('[data-msp-faq-trigger]');
    const panel = item.querySelector('[data-msp-faq-panel]');
    root.querySelectorAll('[data-msp-faq-item]').forEach((other) => {
      if (other !== item) closeItem(other);
    });
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => panel.classList.add('is-open'));
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-msp-faq-accordion]').forEach((root) => {
      if (root.dataset.mspFaqReady === 'true') return;
      root.dataset.mspFaqReady = 'true';
      root.querySelectorAll('[data-msp-faq-item]').forEach((item) => {
        const trigger = item.querySelector('[data-msp-faq-trigger]');
        const panel = item.querySelector('[data-msp-faq-panel]');
        trigger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        panel.hidden = true;
      });
      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-msp-faq-trigger]');
        if (!trigger || !root.contains(trigger)) return;
        const item = trigger.closest('[data-msp-faq-item]');
        if (trigger.getAttribute('aria-expanded') === 'true') closeItem(item);
        else openItem(item);
      });
      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const item = event.target.closest('[data-msp-faq-item]');
        if (item) closeItem(item, true);
      });
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
